export default "__VITE_ASSET__BCtiRtpU__"